var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45252_19820)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32 64.7852C49.6731 64.7852 64 50.4583 64 32.7852C64 15.112 49.6731 0.785156 32 0.785156C14.3269 0.785156 0 15.112 0 32.7852C0 50.4583 14.3269 64.7852 32 64.7852Z",
    fill: "#E50B20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7999 16.7852L27.1999 18.3852H20.8C19.9168 18.3852 19.2 19.102 19.2 19.9852C19.2 20.8684 19.9168 21.5852 20.8 21.5852H24H39.9999H43.1999C44.0831 21.5852 44.7999 20.8684 44.7999 19.9852C44.7999 19.102 44.0831 18.3852 43.1999 18.3852H36.7999L35.1999 16.7852H28.7999ZM20.8 24.7852V45.5852C20.8 47.3532 22.232 48.7852 24 48.7852H39.9999C41.7679 48.7852 43.1999 47.3532 43.1999 45.5852V24.7852H20.8Z",
    fill: "#E50B20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45252_19820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.785156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRedIcon);
export default __webpack_public_path__ + "static/media/delete-red-icon.7d3c4ecf3a5c994c6f5c5722d340d9f4.svg";
export { ForwardRef as ReactComponent };